import { render, staticRenderFns } from "./CancellationCompensation.vue?vue&type=template&id=54642426"
import script from "./CancellationCompensation.vue?vue&type=script&lang=js"
export * from "./CancellationCompensation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports